import React from "react";
import classes from "./styles.module.scss";
import classNames from "classnames";

interface Item {
   title: string;
   description: string;
}

interface ListProps {
   items: Item[]
   className?: string;
}

const List: React.FC<ListProps> = ({ className, items }) => {
   return <ol className={classNames(className, classes.list)}>
      {
         items.map(({ title, description }) => <li key={title} className={classes.listItem}>
            <span className={classes.listItemTitle}>
               {title}
            </span>
            {" "}
            <span className={classes.listItemDescription}>
               {description}
            </span>
         </li>)
      }
   </ol>;
}

export default List;
